var exports = {
  "IW": "TypingUsers.module__typing___Skphbm",
  "Xh": "TypingUsers.module__username___Skphbm",
  "V": "TypingUsers.module__composerStatus___Skphbm",
  "sM": "TypingUsers.module__srOnly___Skphbm",
  "xP": "TypingUsers.module__measure___Skphbm",
};

module.exports = exports;
